import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findBalance = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-integral/v1/detail/balance?` + params,
        method: 'GET'
    })
}

export const immediatePay = (data) => {
    return request({
        url: `${baseUrl}/joins-work/v1/workOrderAudit/immediatePay`,
        method: 'PUT',
        data: data
    })
}


export const addBalance = (params) => {
    return request({
        url: `${baseUrl}/joins-integral/v1/detail/insertIntegralOrder`,
        method: 'POST',
        data: params
    })
}
export const findCashLimitation = () => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_deposit`,
        method: 'GET'
    })
}

export const findAccountBalance = () => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_detail/balance`,
        method: 'GET'
    })
}

export const cashWithdrawal = (data) => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_deposit`,
        method: 'POST',
        data: data
    })
}